module.exports = __webpack_public_path__ + "img/popled.3896ee32.jpeg";